export enum KMTypes {
	KMAfter30 = "30 km",
	KMAfter35 = "35 km",
  KMAfter40 = "40 km",
  KMAfter45 = "45 km",
}